import React from 'react'
import { QRCodeSVG } from 'qrcode.react'
import Icon from './Icon'
import { siteUrl } from '../config'

/**
 * Class of the block, which KioskPage places where the columns leave the most room
 * @type {string}
 */
export const QR_CODE_CLASS = 'kiosk-qr'

/**
 * Name of the site in the header of the block, its address without the protocol
 * @type {string}
 */
const SITE_NAME = siteUrl.replace( /^https?:\/\//, '' )

/**
 * Block on the kiosk screen, like the groups, with a QR code of the site to scan with a phone
 * @returns {JSX.Element} block
 */
const KioskQrCode = () =>
(
  <section className={ `kiosk-group ${ QR_CODE_CLASS }` }>
    <h2 className="kiosk-group-title"><Icon icon="home"/>{ SITE_NAME }</h2>
    <div className="kiosk-group-body">
      <QRCodeSVG value={ siteUrl } title={ siteUrl } marginSize={ 0 }/>
    </div>
  </section>
)

export default KioskQrCode
